import { FC } from 'react';

import { useQueryClient } from '@tanstack/react-query';
import { Link } from 'react-router-dom';

import { partnersQueries } from '@/api/partners.service';

import './Logo.scss';

import { getPublicFileLogo } from '@/api';
import { PartnerDto } from '@/generated-types';

const defaultCompanyUrl = 'https://loanbud.com/';

interface ILogoProps {
	className?: string;
}

const Logo: FC<ILogoProps> = ({ className = '' }) => {
	const queryClient = useQueryClient();

	const data = queryClient.getQueryData<Required<PartnerDto>>(partnersQueries.partner.me.queryKey);

	const companyUrl = data?.url ?? defaultCompanyUrl;

	return (
		<Link
			className={`company-link ${className}`}
			rel="noreferrer"
			target={'_blank'}
			to={companyUrl}
		>
			<img
				alt={'company logo'}
				className={'company-logo'}
				src={getPublicFileLogo(data?.logo?.id)}
			/>
		</Link>
	);
};

export default Logo;
